import React, { useEffect, useState } from "react";
import EnhancedTable from "../elementos/basicos/TablaOficinaLista";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchOficinasFiltersData, fetchEliminarOficina } from "../../peticiones_API/PeticionesGestionPersonasOficinas";
import { ConfirmacionEliminarOficina } from './../elementos/eventos/avisos/VentanaEmergente';
import Titulo from "./../elementos/basicos/Titulo";
import styled from 'styled-components';
import { ToastContainer, toast } from "react-toastify";

const GestionPersonasOficinas = () => {
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();

    let busqueda = params.get("busqueda") || null;
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(false);

    const oficinas = [];

    const [selected, setSelected] = useState([]);
    const [recargar, setRecargar] = useState(false);
    const [eliminarSeleccion, setEliminarSeleccion] = useState({ atributo: 'visible', valor: null });
    const [data, setData] = useState({
            meta: {},
            rows: []
        });

    const construirParametrosURL = (pagina) => {
        let urlParams = `?pagina=${pagina}&registrosPorPag=${registrosPorPag}`;
        if (busqueda !== null && busqueda !== '' && busqueda !== undefined) {
            urlParams += `&busqueda=${busqueda}`;
        }
        if (ordenarColumna !== null) {
            urlParams += `&ordenarColumna=${ordenarColumna}`;
        }
        if (orden !== null) {
            urlParams += `&orden=${orden}`;
        }
        return urlParams;
    };

        useEffect(() => {
            async function fechtPrincipal() {
                try {
                    if (!paginaActual || !registrosPorPag) {
                        const oficinasResponse = await fetchOficinasFiltersData(paginaActual, registrosPorPag);
                        console.log("oficinasResponse ",oficinasResponse);
                        const { data: oficinasData, meta } = oficinasResponse;

                        paginaActual = meta.current_page;
                        registrosPorPag = meta.per_page;
                        
                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                        setData({
                            meta,
                            rows: oficinasData
                        });
                    } else {
                        const urlParams = construirParametrosURL(paginaActual);
                        navigate(`${urlPadre}${urlParams}`);
                        
                        const oficinasResponse = await fetchOficinasFiltersData(paginaActual, registrosPorPag, busqueda, ordenarColumna, orden);
                        const { data: oficinasData, meta } = oficinasResponse;
                        
                        //Para arreglar el problema de estar en otra pagina y que no haya datos
                        if (oficinasData.length === 0 && paginaActual > 1 && meta.total > 0) {
                            const urlParamsPage1 = construirParametrosURL(1);
                            navigate(`${urlPadre}${urlParamsPage1}`);
                            return;
                        }
                        
                        setData({
                            meta,
                            rows: oficinasData
                        });
                    }
                    
                    
                } catch (error) {
                    console.log("Ha habido un error:", error);
                } finally {
                    setLoading(false);
                }
            }
            fechtPrincipal();
        }, [recargar, paginaActual, registrosPorPag, busqueda, ordenarColumna, orden, navigate, urlPadre]);

    const confirmDialog = ConfirmacionEliminarOficina();

    useEffect(() => {
        const eliminar = async () => {
            if (selected.length === 0) {
                setEliminarSeleccion({ ...eliminarSeleccion, valor: null });
                return;
            }

            const confirm = await confirmDialog.showAlert("eliminar", "oficinas");

            // Reset the trigger immediately after showing the dialog
            setEliminarSeleccion({ ...eliminarSeleccion, valor: null });

            if (confirm) {
                let oficinasEliminar = selected;
                let successCount = 0;

                for (const oficinaId of oficinasEliminar) {
                    try {
                        await fetchEliminarOficina(oficinaId);
                        successCount++;
                    } catch (error) {
                        toast.error(`Error al eliminar la oficina ID ${oficinaId}`);
                        console.error("Error al eliminar oficina:", error);
                    }
                }

                if (successCount > 0 && successCount === oficinasEliminar.length) {
                    toast.success(`Se han eliminado ${successCount} oficinas correctamente.`);
                } else if (successCount > 0) {
                    toast.warn(`Se eliminaron ${successCount} de ${oficinasEliminar.length} oficinas.`);
                }

                setSelected([]);
                setRecargar(r => !r);
            }
        };

        if (eliminarSeleccion.valor !== null) {
            eliminar();
        }
    }, [eliminarSeleccion.valor]);

    const header = [
        {
            id: 'nombre',
            numeric: false,
            disablePadding: true,
            label: 'Nombre',
        },
        {
            id: 'direccion',
            numeric: false,
            disablePadding: false,
            label: 'Dirección',
        },
        {
            id: 'provincia',
            numeric: true,
            disablePadding: false,
            label: 'Provincia',
        },
        {
            id: 'poblacion',
            numeric: true,
            disablePadding: false,
            label: 'Población',
        },
        {
            id: 'modificar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];

    if (loading) {
        return <div>Cargando...</div>;
    }

    return ( 
        <>
        <ToastContainer />
            <CabeceraForm>
                <Titulo
                    texto="OFICINAS"
                    
                    tituloTabla="true"
                />
            </CabeceraForm>
            <EnhancedTable
                data={data.rows}
                header={header}
                meta={data.meta}
                oficinas={oficinas}
                selected={selected}
                setSelected={setSelected}
                eliminarSeleccion={eliminarSeleccion}
                setEliminarSeleccion={setEliminarSeleccion}
            />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 0 0% 1% 0%;
`
 
export default GestionPersonasOficinas;